const RichRelevanceBaseInstrumentationController = require('./rr-base-instrumentation-controller');

class RichRelevanceHomeInstrumentationController extends RichRelevanceBaseInstrumentationController {

    constructor($scope, $window, featureService, richRelevanceService, restangular, settings) {
        super($scope, $window, featureService, richRelevanceService);
        this._api = restangular.one('RichRelevance');
        this.richRelevanceService = richRelevanceService;
        this.settings = settings;
        this.$window = $window;
    }
    sendInstrumentation() {
        this.richRelevanceService.getInformation()
            .then(() => {
                if (this.settings.richRelevance.removeDuplicatedProducts) {
                    const placementIdArray = this.placementTypes();

                    if (!placementIdArray || !placementIdArray.length) {
                        return;
                    }

                    this.sendServerInstrumentation(placementIdArray)
                        .then((placement) => {
                            this.richRelevanceService.onPlacementsReceived(placement);
                        });
                } else {
                    this.$window.R3_HOME = new this.$window.r3_home(); // eslint-disable-line new-cap
                    this.addPlacementTypesIfEnabled();
                    this.$window.rr_flush_onload();
                    this.$window.r3();
                }
            });
    }

    sendServerInstrumentation(placementId) {
        // Send request to Trader server
        return this._api.several('Placements', placementId).doGET();
    }
}

const richRelevanceHomeInstrumentationComponentDefinition = {
    controller: ['$scope', '$window', 'FeatureService', 'RichRelevanceService', 'Restangular', 'Settings', RichRelevanceHomeInstrumentationController],
    bindings: {
        // page group and placement ids for base controller.
        pageGroup: '@',
        placementIds: '@',
    },
};

module.exports = {
    RichRelevanceHomeInstrumentationController,
    richRelevanceHomeInstrumentationComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/richrelevance/instrumentation/rr-home-instrumentation.component.js